import { ReactNode } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import { RiExpandDiagonalSLine } from '@remixicon/react';
import classNames from 'classnames';

import { ButtonIcon, Flex, FlexProps, Text } from '@backstage/ui';

const styles = createStyles({
  root: {
    position: 'relative',
    flexDirection: 'column',
  },
});

export interface ActivityItemPanelProps
  extends FlexProps,
    WithStyles<typeof styles> {
  title?: ReactNode;
  onExpand?: () => void;
}

const ActivityItemPanel = ({
  classes,
  className,
  children,
  onExpand,
  title,
  ...props
}: ActivityItemPanelProps) => {
  return (
    <Flex className={classNames(classes.root, className)} {...props}>
      <Flex align="center" justify="between">
        <Text variant="body-medium" weight="bold">
          {title}
        </Text>
        {onExpand && (
          <ButtonIcon
            variant="tertiary"
            size="small"
            icon={<RiExpandDiagonalSLine />}
            onClick={onExpand}
          />
        )}
      </Flex>
      {children}
    </Flex>
  );
};

export default withStyles(styles)(ActivityItemPanel);
